/**
 * Roles constants.
 */
export const ROLE_ADMIN = "admin";
export const ROLE_THERAPIST = "therapist";
export const ROLE_THERAPIST_ADMIN = "therapist_admin";
export const ROLE_USER = "user";
export const ROLES = [ROLE_ADMIN, ROLE_USER, ROLE_THERAPIST, ROLE_THERAPIST_ADMIN];
export const ROLES_THERAPISTS = [ROLE_THERAPIST, ROLE_THERAPIST_ADMIN];

/**
 * Genders.
 */
export const GENDERS = ["female", "male", "other"];

/**
 * Status.
 */
export const STATUS_PENDING = "pending";
export const STATUS_WAITING = "waiting";
export const STATUS_ACTIVE = "active";
export const STATUS_DELETED = "deleted";
export const STATUS_DISABLED = "disabled";
export const STATUS_IS_ACTIVE = "is_active";
export const STATUS = [STATUS_PENDING, STATUS_ACTIVE, STATUS_DISABLED, STATUS_DELETED];
export const USER_STATUS = [STATUS_PENDING, STATUS_ACTIVE, STATUS_DISABLED, STATUS_WAITING];
/**
 * Reminder in days.
 */
export const REMINDER_IN_2_DAYS = 2;
export const REMINDER_IN_3_DAYS = 3;
export const REMINDER_IN_5_DAYS = 5;
export const REMINDER_IN_7_DAYS = 7;

/**
 * GCStorage Main folders.
 */
export const ONBOARDING_DIRECTORY = "Onboarding";
export const ACTIVITIES_DIRECTORY = "Activities";
export const USERS_DIRECTORY = "Users";
export const TEST_FILES_DIRECTORY = "TestFiles";

/**
 * GCStorage Onboarding folders.
 */
export const FOLDER_DOCUMENTS = "Documents";
export const FOLDER_TEMPLATES = "Templates";

/**
 * GCStorage user folders.
 */
export const FOLDER_ONBOARDING = "Onboarding";
export const FOLDER_PICTURES = "Pictures";
export const FOLDER_THERAPY_REPORTS = "TherapyReports";
export const FOLDER_UPLOADS = "Uploads";

/**
 * Events types.
 */
export const EVENT_FREE_SLOT = "free-slot";
export const EVENT_SESSION = "session";
export const EVENT_GROUPED_SESSION = "grouped_session";
export const EVENT_CANCELED = "canceled";
export const EVENT_PAID_CANCELED = "paid-canceled";
export const EVENT_VACATION = "vacation";
export const EVENT_SICK_LEAVE = "sick-leave";
export const EVENT_PUBLIC_HOLIDAY = "public-holiday";
export const EVENT_COMPANY_HOLIDAY = "company-holiday";
export const EVENT_EDUCATIONAL_LEAVE = "educational-leave";
export const THERAPIST_ABSENCE_EVENT_TYPES = [
    EVENT_VACATION,
    EVENT_SICK_LEAVE,
    EVENT_PUBLIC_HOLIDAY,
    EVENT_COMPANY_HOLIDAY,
    EVENT_EDUCATIONAL_LEAVE
];
/**
 * Recurrence ranges.
 */
export const RANGE_CURRENT = "current";
export const RANGE_CURRENT_FOLLOWING = "currenton";
export const RANGE_ALL = "all";
export const RECURRENCE_RANGES = [RANGE_CURRENT, RANGE_CURRENT_FOLLOWING, RANGE_ALL];

/**
 * Recurrence frequency.
 */
export const FREQ_NONE = "none";
export const FREQ_DAILY = "daily";
export const FREQ_WEEKDAYS = "weekdays";
export const FREQ_WEEKLY = "weekly";
export const FREQ_EVERYXWEEKS = "everyXWeeks";
export const FREQ_MONTHLY = "monthly";
export const FREQ_YEARLY = "yearly";

/**
 * Events actions permissions.
 */
export const ADD_FREE_SLOT = "add_free-slot";
export const EDIT_FREE_SLOT = "edit_free-slot";
export const BOOK_FREE_SLOT = "book_free-slot";
export const DELETE_FREE_SLOT = "delete_free-slot";
export const BOOK_GROUPED_SESSION = "book_grouped_session";
export const EDIT_GROUPED_SESSION = "edit_grouped_session";
export const DELETE_SESSION = "delete_session";
export const EDIT_VACATION = "edit_vacation";
export const DELETE_VACATION = "delete_vacation";
export const EDIT_SICK_LEAVE = "edit_sick-leave";
export const DELETE_SICK_LEAVE = "delete_sick-leave";
export const EDIT_PUBLIC_HOLIDAY = "edit_public-holiday";
export const DELETE_PUBLIC_HOLIDAY = "delete_public-holiday";
export const EDIT_COMPANY_HOLIDAY = "edit_company-holiday";
export const DELETE_COMPANY_HOLIDAY = "delete_company-holiday";
export const EDIT_EDUCATIONAL_LEAVE = "edit_educational-leave";
export const DELETE_EDUCATIONAL_LEAVE = "delete_educational-leave";
export const THERAPIST_ABSENCE_PERMISSIONS = [
    EDIT_VACATION,
    DELETE_VACATION,
    EDIT_SICK_LEAVE,
    DELETE_SICK_LEAVE,
    EDIT_PUBLIC_HOLIDAY,
    DELETE_PUBLIC_HOLIDAY,
    EDIT_COMPANY_HOLIDAY,
    DELETE_COMPANY_HOLIDAY,
    EDIT_EDUCATIONAL_LEAVE,
    DELETE_EDUCATIONAL_LEAVE
];
/**
 * Sessions actions.
 */
export const CANCEL_ANYWAY = "cancel-anyway";
export const SESSION_CANCEL_ANYWAY = "session-cancel-anyway";
export const UPDATE_GROUPED_SESSION = "update-grouped-session";
export const RESCHEDULE_GROUPED_SESSION = "reschedule-grouped-session";
export const RESCHEDULE = "reschedule";
export const SKIP = "skip";

/**
 * Results.
 */
export const CORRECT = "correct";
export const INCORRECT = "incorrect";
export const MISTAKES = "mistakes";
export const TOTAL = "total";
export const TIME = "time";
export const ERRORS = "errors";

/**
 * Games types.
 */
export const GAME_SPEED_READING = "speed_reading";

/**
 * Fonts types.
 */
export const COMPUTER = "computer";
export const HANDWRITING = "handwriting";

/**
 * User Registration/Onboarding steps.
 */
// export const STEP_APPROVAL = "approval";
// export const STEP_CONTRACT = "contract";
export const STEP_SET_PASSWORD = "set_password";
export const STEP_PLANS = "plans";
export const STEP_PAYMENT = "payment";
export const STEP_UPSELL = "upsell";
export const STEP_EQUIPMENTS = "equipments";
export const STEP_THERAPY_DATE = "therapy_date";
export const STEP_LIMITED_DASHBOARD = "limited_dashboard";
export const STEP_CHILD = "child";
export const STEP_THERAPIST = "therapist";
export const STEP_SESSION_SCHEDULE = "session_schedule";
export const STEP_TECHNICAL_SETUP = "technical_setup";

/**
 * Mollie payment status.
 */
export const PAYMENT_STATUS_AUTHORIZED = "authorized";
export const PAYMENT_STATUS_CANCELED = "canceled";
export const PAYMENT_STATUS_EXPIRED = "expired";
export const PAYMENT_STATUS_FAILED = "failed";
export const PAYMENT_STATUS_OPEN = "open";
export const PAYMENT_STATUS_PAID = "paid";
export const PAYMENT_STATUS_VALID = "valid";
export const PAYMENT_STATUS_PENDING = "pending";

export const FAULTY_PAYMENTS = [PAYMENT_STATUS_CANCELED, PAYMENT_STATUS_EXPIRED, PAYMENT_STATUS_FAILED];

/**
 * Mollie payment methods.
 */

export const METHOD_BANKTRANSFER = "banktransfer";
export const METHOD_DIRECTDEBIT = "directdebit";

/**
 * Mollie subscriptions.
 */

export const SUBSCRIPTION_STATUS_ACTIVE = "active";
export const SUBSCRIPTION_STATUS_CANCELED = "canceled";
export const UPSELL_STATUS_ORDERED = "ordered";
// export const UPSELL_STATUS_BOUGHT = "purchased";
export const UPSELL_FROM_SALES = "sales";
export const SUBSCRIPTION_NAME_THERAPY = "therapy";
export const SUBSCRIPTION_NAME_STRONGPARENTS = "strongparents";

/**
 * School types.
 */
export const SCHOOL_TYPE_COMPREHENSIVE = "comprehensive";
export const SCHOOL_TYPE_ELEMENTARY = "elementary";
export const SCHOOL_TYPE_INTERNATIONAL = "international";
export const SCHOOL_TYPE_MONTESSORI = "montessori";
export const SCHOOL_TYPE_OTHER = "other";
export const SCHOOL_TYPE_SECONDARY_BASIC = "secondary-basic";
export const SCHOOL_TYPE_SECONDARY_GYMNASIUM = "secondary-gymnasium";
export const SCHOOL_TYPE_SECONDARY_MODERN = "secondary-modern";
export const SCHOOL_TYPE_SPECIAL = "special";
export const SCHOOL_TYPE_WALDORF = "waldorf";

export const SCHOOL_TYPES = [
    SCHOOL_TYPE_ELEMENTARY,
    SCHOOL_TYPE_SECONDARY_BASIC,
    SCHOOL_TYPE_SECONDARY_MODERN,
    SCHOOL_TYPE_SECONDARY_GYMNASIUM,
    SCHOOL_TYPE_COMPREHENSIVE,
    SCHOOL_TYPE_SPECIAL,
    SCHOOL_TYPE_INTERNATIONAL,
    SCHOOL_TYPE_WALDORF,
    SCHOOL_TYPE_MONTESSORI,
    SCHOOL_TYPE_OTHER
];

/**
 * School reliefs.
 */
export const SCHOOL_RELIEF_COMPENSATION_DISADVANTAGES = "compensation_disadvantages";
export const SCHOOL_RELIEF_GRADE_PROTECTION = "grade_protection";
export const SCHOOL_RELIEF_INDIVIDUAL_SUPPORT = "individual_support";
export const SCHOOL_RELIEF_NO_SUPPORT = "no_support";

export const SCHOOL_RELIEFS = [
    SCHOOL_RELIEF_COMPENSATION_DISADVANTAGES,
    SCHOOL_RELIEF_GRADE_PROTECTION,
    SCHOOL_RELIEF_INDIVIDUAL_SUPPORT,
    SCHOOL_RELIEF_NO_SUPPORT
];

/**
 * Existing diagnoses.
 */
export const DIAGNOSE_ADHS = "adhs";
export const DIAGNOSE_ANXIETY_DISORDER = "anxiety_disorder";
export const DIAGNOSE_DEPRESSION = "depression";
export const DIAGNOSE_LANGUAGE_DEVELOPMENT_DISORDER = "language_development_disorder";
export const DIAGNOSE_MATH_DISORDER = "math_disorder";
export const DIAGNOSE_NONE = "none";

export const DIAGNOSES = [
    DIAGNOSE_ADHS,
    DIAGNOSE_ANXIETY_DISORDER,
    DIAGNOSE_MATH_DISORDER,
    DIAGNOSE_DEPRESSION,
    DIAGNOSE_LANGUAGE_DEVELOPMENT_DISORDER,
    DIAGNOSE_NONE
];

/**
 * Status dyslexia diagnostics
 */
export const CHILD_DYSLEXIA_DIAGNOSTICS_NO_DIAGNOSTICS = "no_diagnostics";
export const CHILD_DYSLEXIA_DIAGNOSTICS_DIAGNOSTIC_RESULTS_PENDING = "diagnostic_results_pending";
export const CHILD_DYSLEXIA_DIAGNOSTICS_A_DYSLEXIA = "a_dyslexia";
export const CHILD_DYSLEXIA_DIAGNOSTICS_NO_DYSLEXIA = "no_dyslexia";
export const CHILD_DYSLEXIA_DIAGNOSTICS_OTHER = "other";

export const CHILD_DYSLEXIA_DIAGNOSTICS = [
    CHILD_DYSLEXIA_DIAGNOSTICS_NO_DIAGNOSTICS,
    CHILD_DYSLEXIA_DIAGNOSTICS_DIAGNOSTIC_RESULTS_PENDING,
    CHILD_DYSLEXIA_DIAGNOSTICS_A_DYSLEXIA,
    CHILD_DYSLEXIA_DIAGNOSTICS_NO_DYSLEXIA,
    CHILD_DYSLEXIA_DIAGNOSTICS_OTHER
];

/**
 * Document exercises types.
 */
export const WARMUP = "warmup";
export const CONTENT = "content";
export const CONCLUSION = "conclusion";
export const EXERCISES_TYPES = [WARMUP, CONTENT, CONCLUSION];

/**
 * Test types.
 */
// export const TYPE_SLRTIIREADING = "slrt_reading";
// export const TYPE_SLRTIIWRITING = "slrt_writing";
// export const TYPE_ELFEII = "elfe";
// export const TYPE_RST47 = "rst47";
export const TYPE_TRAININGSENTENCES_2_7 = "trainingsentences_2_7";
export const TYPE_TRAININGSENTENCES_8 = "trainingsentences_8";
export const TYPE_TRAININGSENTENCES_9_12 = "trainingsentences_9_12";
export const TYPE_ALPHABET = "alphabet";
export const TYPE_TRAININGWORDS = "trainingwords";
export const TYPE_READING_ALOUD = "reading_aloud";
export const TYPE_SYLLABLE = "syllable";
export const TYPE_LESEN_6_7 = "lesen_6_7";
export const TYPE_LESEN_8_9 = "lesen_8_9";
export const TYPE_LESEK = "lesek";
export const TYPE_HSP = "hsp";

// TEST NAMES
export const ELFEII_NAME = "ELFE-II";
export const SLRTII_LESEBLATT_FORM_A_WOERTER = "SLRT-II Leseblatt Form A (Wörter)";
export const SLRTII_RECHTSCHREIB_3UND4_FORM_A = "SLRT-II Rechtschreib 3. und 4. Form A";
export const SLRTII_LESEBLATT_FORM_A_PSEUDOWOERTER = "SLRT-II Leseblatt Form A (Pseudowörter)";
export const SLRTII_LESEBLATT_FORM_B_WOERTER = "SLRT-II Leseblatt Form B (Wörter)";
export const SLRTII_LESEBLATT_FORM_B_PSEUDOWOERTER = "SLRT-II Leseblatt Form B (Pseudowörter)";
export const SLRTII_RECHTSCHREIB_1UND2_FORM_A = "SLRT-II Rechtschreib 1. und 2. Form A";
export const SLRTII_RECHTSCHREIB_1UND2_FORM_B = "SLRT-II Rechtschreib 1. und 2. Form B";
export const SLRTII_RECHTSCHREIB_3UND4_FORM_B = "SLRT-II Rechtschreib 3. und 4. Form B";
/**
 * Test general fileds.
 */
export const OPTION_CORRECT = "correct";
export const OPTION_INCORRECT = "incorrect";
export const OPTION_SKIPPED = "skipped";
export const BASE_OPTIONS = [OPTION_CORRECT, OPTION_INCORRECT];
export const COMPLETE_OPTIONS = [...BASE_OPTIONS, OPTION_SKIPPED];
export const N_ERROR = "n";
export const O_ERROR = "o";
export const GK_ERROR = "gk";
export const ERRORS_TYPES = [N_ERROR, O_ERROR, GK_ERROR];
export const LEVEL = "level";
export const LEVELS = "levels";

export const LEVEL_TYPES = [
    "easy",
    "medium",
    "hard",
    "level-2",
    "level-3",
    "level-4",
    "level-5",
    "level-6",
    "level-7",
    "level-8",
    "level-9",
    "level-10",
    "level-11",
    "level-12"
];

export const CORRECT_LETTERS_PER_MINUTE = "correct-letters-per-minute";
export const WORDS_PER_MINUTE = "amount-of-words-per-minute";
export const CORRECT_WORDS_PER_MINUTE = "number-of-correct-words-per-minute";

export const TEST_RESULTS_EDITABLE_HEADER_FIELDS = ["school-years", "school-months", "school-semester", "class"];
export const TEST_RESULTS_EDITABLE_HEADER = [
    ELFEII_NAME,
    SLRTII_LESEBLATT_FORM_A_WOERTER,
    SLRTII_RECHTSCHREIB_3UND4_FORM_A,
    SLRTII_LESEBLATT_FORM_A_PSEUDOWOERTER,
    SLRTII_LESEBLATT_FORM_B_WOERTER,
    SLRTII_LESEBLATT_FORM_B_PSEUDOWOERTER,
    SLRTII_RECHTSCHREIB_1UND2_FORM_A,
    SLRTII_RECHTSCHREIB_1UND2_FORM_B,
    SLRTII_RECHTSCHREIB_3UND4_FORM_B
];

/**
 * Chart Fileds
 */
export const COLUMN = "column";
export const AREA = "area";
export const LINE = "line";

/**
 * Chart TYPES
 */
export const AREA_CHART = "area";
export const LINE_CHART = "line";

/**
 * Grouped Tests types.
 */
export const ALPHABET_TEST = "Alphabet Übung";
export const WRITING_TRAININGWORDS_TEST = "Schreib Trainingswörter";
export const READING_TRAININGWORDS_TEST = "Lese Trainingswörter";
export const TRAINING_SENTENCES_TEST = "Schreib Trainingssätze";
export const READING_ALOUD_TEST = "Lautleseprotokoll";
export const SYLLABLE_TEST = "Silbenteppiche";

export const GROUPED_TESTS = [
    { name: SYLLABLE_TEST, order: 1 },
    { name: READING_TRAININGWORDS_TEST, order: 2 },
    { name: READING_ALOUD_TEST, order: 3 },
    { name: ALPHABET_TEST, order: 4 },
    { name: WRITING_TRAININGWORDS_TEST, order: 5 },
    { name: TRAINING_SENTENCES_TEST, order: 6 }
];

export const TYPE_WRITING = [ALPHABET_TEST, WRITING_TRAININGWORDS_TEST, TRAINING_SENTENCES_TEST];
export const TYPE_READING = [READING_TRAININGWORDS_TEST, READING_ALOUD_TEST, SYLLABLE_TEST];

/**
 * Others.
 */
export const REMOVE = "remove";
export const INCREMENT = "increment";
export const DECREMENT = "decrement";

/**
 * CRUD Operations.
 */
export const CREATE = "create";
export const UPDATE = "update";
export const DELETE = "delete";
export const CANCEL = "cancel";

/**
 * Locale.
 */
export const SELECTED_LANGUAGE_STORAGE_KEY = "selected-language";

// Payment constants
export const YEARLY_DISCOUNT_PERCENTAGE = 5;

// Therapy start reminder constants
export const THERAPY_START_REMINDER_DAYS = 10;

// Upsell constants
export const UPSELL_AMOUNT = 35;

export const VIDEO_COURSE_URL = "https://www.youtube.com/watch?v=P9KNI6NnMho"
    .replace("//youtu.be/", "//www.youtube.com//watch?v=")
    .replace("watch?v=", "embed/");

// Circle space id
export const CIRCLE_ELTERNSTARK_SPACE_ID = 1682391;

// PAGINATION
export const LIMIT = 15;
export const PAGE = 1;
export const ROWS_PER_PAGE = [5, 10, 15, 25, 50];

// Trustpilot
export const TRUSTPILOT_URL = "https://de.trustpilot.com/evaluate/wortheld-werden.de";

// Feedback constants
export const MAX_POSTPONE_COUNT = 3;
export const ONBOARDING_PHASE_MONTHS = 2;
export const ONBOARDING_PHASE_DAYS = 90;
export const THERAPY_PROGRESS_PHASE_MONTHS = 6;

// Local storage keys
export const PATIENT_UPLOADS_VIEW_KEY = "patient-uploads-view";
export const PATIENT_UPLOADS_VIEW = {
    LIST: "list",
    GALLERY: "gallery"
} as const;
